var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.714508 4.4835C0.714508 2.06929 2.67161 0.112183 5.08583 0.112183H12.4481C14.8623 0.112183 16.8194 2.06929 16.8194 4.4835V15.5268C16.8194 17.941 14.8623 19.8982 12.4481 19.8982H5.08583C2.67161 19.8982 0.714508 17.941 0.714508 15.5268V4.4835ZM5.08583 4.71357C4.70464 4.71357 4.39562 5.02259 4.39562 5.40378C4.39562 5.78497 4.70464 6.09399 5.08583 6.09399H12.4481C12.8292 6.09399 13.1383 5.78497 13.1383 5.40378C13.1383 5.02259 12.8292 4.71357 12.4481 4.71357H5.08583ZM4.39562 10.0052C4.39562 9.62398 4.70464 9.31496 5.08583 9.31496H12.4481C12.8292 9.31496 13.1383 9.62398 13.1383 10.0052C13.1383 10.3864 12.8292 10.6954 12.4481 10.6954H5.08583C4.70464 10.6954 4.39562 10.3864 4.39562 10.0052ZM5.08583 13.9164C4.70464 13.9164 4.39562 14.2254 4.39562 14.6066C4.39562 14.9878 4.70464 15.2968 5.08583 15.2968H8.76694C9.14813 15.2968 9.45715 14.9878 9.45715 14.6066C9.45715 14.2254 9.14813 13.9164 8.76694 13.9164H5.08583Z",
    fill: "#1F2024"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedia);
export default __webpack_public_path__ + "static/media/media.ed46a01b5e0265d8f2ce8fd3b3fcf9a8.svg";
export { ForwardRef as ReactComponent };